import { client } from '../api/client'
import { Linking, Platform } from 'react-native'
import { paycheckbody, paycheckdetails } from '../types/paycheckTypes'
import * as FileSystem from 'expo-file-system'
import * as WebBrowser from 'expo-web-browser'

const paycheck = (data): Promise<paycheckbody> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.patch(`/PdfCreator/paystub`, data)
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not fetch data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const fetchW2Forms = (
  entityid,
  empnumber,
  essUserKey,
  obkey,
  CorpId,
  storeId
): Promise<paycheckbody> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `OnBoarding/GetW2Information?EntityId=${entityid}&EmployeeNumber=${empnumber}&essUserKey=${essUserKey}&obKey=${obkey}&CorpId=${CorpId}&storeId=${storeId}`
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not fetch data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}
const fetchw2file = (
  w2id,
  essuserkey,
  obkey,
  year,
  isCorrectionW2,
  seqNo
): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `/OnBoarding/GetW2Pdf?w2Id=${w2id}&EssUserKey=${essuserkey}&Obkey=${obkey}&year=${year}&ForceDelete=false&isCorrectionW2=${isCorrectionW2}&seqNo=${seqNo}`,
        { responseType: 'arraybuffer' }
      )
      //
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ mesage: 'could not fetch data' })
      }
    } catch (err) {
      reject(err)
    }
  })
}

const updateDirectDeposit = (
  amount,
  essUserKey,
  accountnumber,
  AccountType,
  RoutingNumber,
  data,
  bank
): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.post('/Shift/CreateDepositForm', data, {
        params: {
          amount,
          EssUserKey: essUserKey,
          AccountNumber: accountnumber,
          AccountType,
          RoutingNumber,
          FinancialInstitution: bank
        },
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not post   data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const fetchCurrentWeekEarnings = (
  essUserKey: number,
  essobKey: number,
  employeeNumber: number,
  userId
): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `/PayStub/CurrentEarnings?essUserKey=${essUserKey}&essobKey=${essobKey}&employeeNumber=${employeeNumber}&userId=${userId}`
      )

      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not fetch data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const getDepositDetails = (essUserKey: number): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `/Shift/GetDepositForm?EssUserKey=${essUserKey}`
      )

      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not fetch data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const getEmployeeResources = (essUserKey: number): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `OnBoarding/GetEmployeeResources?obkey=${essUserKey}`
      )

      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not fetch data' })
      }
    } catch (error) {
      reject({ message: 'Network Error' })
    }
  })
}

const downloadFile = async (url: string) => {
  const pathParts = url?.split('/')
  const lastPart = pathParts[pathParts.length - 1]

  if (Platform.OS == 'android' || Platform.OS == 'ios') {
    try {
      // const apiResponse = await client.patch(`/PdfCreator/paystub`, )
      // console.log(apiResponse)
      // const Filesdata = apiResponse.data
      // const fileUrl = Filesdata.uri
      const fileName = lastPart
      const filePath = `${FileSystem.documentDirectory}${fileName}`

      const { uri } = await FileSystem.downloadAsync(url, filePath)

      // console.log('Downloaded file to:', uri);
      await WebBrowser.openBrowserAsync(url)
    } catch (error) {
      // console.error('Error ', error);
    }
  } else {
    try {
      Linking.openURL(url)
    } catch (error) {
      console.error('Error opening the web browser:', error)
    }
  }
}

const editDepositDetails = (
  amount,
  userkey,
  accountnumber,
  accounttype,
  routingnumber,
  depositkey,
  imgdata,
  bank
): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.put('/Shift/UpdateDepositForm', imgdata, {
        params: {
          amount,
          EssUserKey: userkey,
          AccountNumber: accountnumber,
          AccountType: accounttype,
          RoutingNumber: routingnumber,
          DepositKey: depositkey,
          FinancialInstitution: bank
        },
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not update data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const deleteDepositDetails = (depositkey): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const resposne = await client.delete(
        `/Shift/DeleteDepositForm?DepositKey=${depositkey}`
      )
      if (resposne.status === 200) {
        resolve(resposne.data)
      } else {
        reject({ message: 'could not delete data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const getpdfblob = (payid, employeenumber) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `/PdfCreator/GetPayStubPdf?PayId=${payid}&EmpNum=${employeenumber}`,
        { responseType: 'arraybuffer' }
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'Could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const getpdfbase64 = (storepolicykey) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(
        `/OnBoarding/GetEmployeeResourcesPdf?StorePolicyKey=${storepolicykey}`
      )
      if (response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'Could not post data' })
      }
    } catch (error) {
      reject(error)
    }
  })
}

const fetchBankNameByRoutingNumber = (routingNumber: string) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await client.get(`/OnBoarding/RoutingBankDetails`, {
        params: {
          aba: routingNumber
        }
      })
      if (response && response.status === 200) {
        resolve(response.data)
      } else {
        reject({ message: 'could not get data' })
      }
    } catch (err) {
      reject(err)
    }
  })
}
export const paycheckservice = {
  downloadFile,
  paycheck,
  fetchCurrentWeekEarnings,
  fetchW2Forms,
  updateDirectDeposit,
  getDepositDetails,
  getEmployeeResources,
  editDepositDetails,
  deleteDepositDetails,
  getpdfblob,
  fetchw2file,
  getpdfbase64,
  fetchBankNameByRoutingNumber
}
